import {
    ChangeDetectorRef,
    Component,
    OnInit,
    Inject,
    AfterViewInit,
    ViewChild,
    ElementRef, Input, Output
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators
} from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@app/utils/get-api-url';

// import { TemplatesConfigService } from '@app/features/system-settings/general-custom-templates-config/services/templates-config.service';
import { SystemSettingsService } from '@app/services';
import {JobViewService} from "@app/features/customers/customer/jobs-view/service/job-view-service";

declare var $: any;

@Component({
    selector: 'app-add-pricing-item',
    templateUrl: './add-pricing-item.html',
    styleUrls: ['./add-pricing-item.scss']
})

// tslint:disable-next-line:component-class-suffix
export class AddPricingItem implements OnInit {

    public onClose: Subject<boolean>;
    title: string = 'Add new pricing item';
    closeBtnName: string = 'Cancel';
    form: FormGroup;
    action: string = '';
    formModel = {
        pricing_item: '',
        unitprice: '',
        qty: '',
        tax: '',
        min_included: '',
        total: ''
    };
    select2Config: any;
    selectedPartId: any;
    selectedKitParts: any[] = [];
    jobId:number;
    customerId:number;
    customerType:string;
    @ViewChild('saveBtn') saveBtn: ElementRef;
    @Input()enablePartStatus = 3;
    select2PartStatusConfig:any={};
    partStatus = [];
    searchResults: any =[];
    seletedItem: any = null;
    @Input() taxList: any[] = [];
    @Input() excludePricingItems: Array<number | string> = [];
    select2TaxConfig: any = {};
    taxLable = 'VAT';
    contractId: any;

    constructor(
        private formBuilder: FormBuilder,
        @Inject('$scope') private ajsScope,
        // private httpService: TemplatesConfigService,
        public bsModalRef: BsModalRef,
        private changeDetector: ChangeDetectorRef,
        private systemSettingsService: SystemSettingsService,
        private jobViewService: JobViewService,
    ) {}

    ngOnInit() {
        this.taxLable = this.ajsScope.taxLabel;
        this.onClose = new Subject();
        this.form = this.formBuilder.group({
            pricing_item: [this.formModel.pricing_item, Validators.required],
            unitprice: [this.formModel.unitprice, [Validators.required]],
            qty:  [this.formModel.qty, [Validators.required, Validators.pattern(/^\d+$/), Validators.min(1)]],
            tax:  [this.formModel.tax, Validators.required],
            min_included: [this.formModel.min_included, [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/), Validators.min(0)]],
            total: [this.formModel.total, Validators.required],
        });
        this.select2TaxConfig = {
            width: '100%',
            data: this.taxList
        };
        this.initSelect2Config();
    }

    initSelect2Config() {
        const excludePricingItems = (this.excludePricingItems || [])
            .map(id => String(id).trim())
            .filter(id => id !== '')
            .join(',');
        this.select2Config = {
            multiple: false,
            width: '100%',
            placeholder: 'Select a part kit',
            allowClear: true,
            minimumInputLength: 2,
            ajax: {
                url: `${environment.apiHost}${environment.apiBasePath}get_pricing_items?customerId=${this.customerId}&contractId=${this.contractId}&excludePricingItems=${encodeURIComponent(excludePricingItems)}`,
                data: (searchText, page) => {
                    if (!searchText) { return false; }
                    return {'q': encodeURIComponent(searchText) };
                },
                results: (data) => {
                    this.searchResults = data;
                    return { results: data || [] };
                }
            }
        };

    }
    get f() {
        return this.form.controls;
    }

    save() {
        if (this.form.invalid) { return; }
        this.action = 'saving';
        const innerPayload = {
            pricing_item: String(this.form.get('pricing_item').value),
            PI_includedMinutes: String(this.form.get('min_included').value),
            PI_quantity: String(this.form.get('qty').value),
            PI_total: String(this.form.get('total').value),
            PI_unitprice: String(this.form.get('unitprice').value),
            Tax_rate_id: String(this.form.get('tax').value),
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(innerPayload));
        this.jobViewService.savePricingItem(this.customerId, this.jobId, this.customerType, formData)
            .subscribe(
                (resp) => {
                    this.action = '';
                    this.onClose.next(true);
                    this.bsModalRef.hide();
                },
                (error) => {
                    this.action = '';
                    console.error('Error saving:', error);
                }
            );
    }


    onSelectingCondition(id) {
        this.seletedItem = this.searchResults.find(obj => obj.id == id);
        if (this.seletedItem) {
            this.form.patchValue({
                pricing_item: this.seletedItem.id || '',
                unitprice: this.seletedItem.unitprice,
                vat: this.seletedItem.Vat,
                tax: this.seletedItem.taxId,
                min_included: '0',
                qty: 1
            });
            const taxSelect = document.getElementById('tax') as any;
            if (taxSelect && $(taxSelect).data('select2')) {
                $(taxSelect).val(this.seletedItem.taxId).trigger('change');
            }
            this.onQtyKeyup();
        } else {
            this.form.patchValue({ unitprice: '' });
        }
    }

    onQtyKeyup() {
        this.updateTotal();
    }
    updateTotal() {
        const qtyCtrl = this.form.get('qty');
        const unitCtrl = this.form.get('unitprice');
        const totalCtrl = this.form.get('total');

        const qtyRaw = qtyCtrl ? qtyCtrl.value : null;
        const unitRaw = unitCtrl ? unitCtrl.value : null;

        const qty = Number(qtyRaw || 0);
        const unit = Number(unitRaw || 0);

        if (!isFinite(qty) || !isFinite(unit)) {
            if (totalCtrl) { totalCtrl.setValue('', { emitEvent: false }); }
            return;
        }

        const total = unit * qty;
        if (totalCtrl) { totalCtrl.setValue(total.toFixed(2), { emitEvent: false }); }
    }

}
